<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>booth</title>
    <path
      fill="#679940"
      d="M31.279 7.756l-14.781-5.010c-0.142-0.036-0.284-0.036-0.426 0l-15.208 4.832c-0.249 0.071-0.462 0.32-0.497 0.569s0.071 0.533 0.32 0.675l2.914 1.954v13.396c0 0.32 0.213 0.604 0.497 0.675l11.903 3.518c0.071 0.036 0.142 0.036 0.213 0.036s0.142 0 0.213-0.036l11.903-3.518c0.32-0.107 0.497-0.355 0.497-0.675v-13.396l2.594-1.777c0.213-0.142 0.355-0.426 0.32-0.675s-0.213-0.497-0.462-0.569zM15.503 26.731l-10.482-3.091v-12.685l10.482-3.056v18.832zM27.441 23.639l-10.482 3.091v-18.832l10.482 3.056v12.685zM28.010 9.64l-11.584-3.376c0 0-0.036 0-0.036 0-0.036 0-0.071 0-0.071 0-0.036 0-0.071 0-0.071 0-0.036 0-0.036 0-0.071 0s-0.071 0-0.071 0c0 0-0.036 0-0.036 0l-11.619 3.376-1.706-1.137 13.538-4.335 13.218 4.477-1.492 0.995z"
    />
  </svg>
</template>

<script>
export default {
    name: "OpenboxIcon"
}
</script>


// WEBPACK FOOTER //
// src/icons/OpenboxIcon.vue